import React from "react";
import { Link } from "react-router-dom";
import { ChevronLeft } from "lucide-react";

export default function Privacy() {
  return (
    <div className="min-h-screen bg-stone-50">
      <header className="bg-white border-b border-stone-200 px-4 md:px-8 py-4">
        <div className="max-w-3xl mx-auto flex items-center justify-between">
          <Link to="/" className="inline-flex items-center gap-1 text-stone-600 hover:text-stone-900 text-sm">
            <ChevronLeft size={16} /> ホームへ戻る
          </Link>
          <span className="text-xs text-stone-400">最終更新: 2026年5月18日</span>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-4 md:px-8 py-10">
        <h1 className="font-display text-3xl md:text-4xl font-black text-stone-900 mb-2">プライバシーポリシー</h1>
        <p className="text-stone-600 text-sm mb-8">
          やさまるタイム(以下「本サービス」)は、お客様の個人情報の重要性を認識し、適切に取り扱うことに努めます。本プライバシーポリシーは、本サービスにおける個人情報の取り扱いについて定めるものです。
        </p>

        <Section title="1. 取得する情報">
          <p>本サービスは、以下の情報を取得します。</p>
          <ul className="list-disc ml-6 mt-2 space-y-1">
            <li>企業情報(企業名、顧客ID、管理者の氏名・メールアドレス)</li>
            <li>従業員情報(氏名、時給、役割)</li>
            <li>勤怠記録(出勤・退勤・休憩の日時、編集履歴)</li>
            <li>決済情報(Stripe社を通じた決済処理に必要な情報。カード番号は当社では保持しません)</li>
            <li>ブラウザCookieおよびアクセスログ(IPアドレス、ユーザーエージェント、アクセス日時)</li>
          </ul>
        </Section>

        <Section title="2. 利用目的">
          <ul className="list-disc ml-6 space-y-1">
            <li>本サービスの提供・運営・改善のため</li>
            <li>本人確認、認証、不正利用の防止</li>
            <li>利用料金の決済、領収書発行</li>
            <li>サービスに関するお知らせ、サポート対応</li>
            <li>統計データの作成(個人を特定できない形式に加工)</li>
          </ul>
        </Section>

        <Section title="3. 第三者提供">
          <p>当社は、法令に基づく場合および以下の場合を除き、お客様の個人情報を第三者に提供しません。</p>
          <ul className="list-disc ml-6 mt-2 space-y-1">
            <li>お客様の同意がある場合</li>
            <li>決済処理のため Stripe, Inc. に必要最小限の情報を提供する場合</li>
            <li>本サービスの運営委託先(サーバー・ホスティング)に必要範囲で開示する場合(秘密保持契約の上)</li>
          </ul>
        </Section>

        <Section title="4. 安全管理措置">
          <p>当社は、お客様の個人情報の漏洩、滅失、毀損を防止するため、技術的・組織的に適切な安全管理措置を講じます。具体的には、通信のSSL/TLS暗号化、データベースの認証管理、アクセスログの記録などを実施しています。</p>
        </Section>

        <Section title="5. データの保存方針とお客様の責任">
          <p>
            勤怠記録は、サービス契約期間中はお客様の管理画面から閲覧・編集・<strong>CSV出力</strong>を行えます。<br />
            労働基準法第109条により、賃金台帳・出勤簿等の保存義務は<strong>使用者(雇用主)であるお客様自身</strong>に課されており、当社はこれを代行する義務を負いません。<br />
            つきましては、勤怠データは定期的にCSV出力でバックアップを取得し、お客様の責任において保管してください。<br />
            契約終了・解約後、当社が保有する勤怠データは削除する場合がありますので、必要なデータは契約終了前に必ずCSV出力でバックアップをお願いいたします。
          </p>
        </Section>

        <Section title="6. Cookieの使用">
          <p>本サービスはログイン状態の維持等のためにCookieを使用します。ブラウザの設定によりCookieを無効化することができますが、その場合、一部機能がご利用いただけない場合があります。</p>
        </Section>

        <Section title="7. お客様の権利">
          <p>お客様は、当社が保有する自身の個人情報について、開示・訂正・削除・利用停止を求めることができます。ご希望の際は、管理画面に登録のメールアドレスから当社までご連絡ください。</p>
        </Section>

        <Section title="8. 本ポリシーの変更">
          <p>当社は、必要に応じて本プライバシーポリシーを変更することがあります。変更後の内容は本サービス内に掲示した時点で効力を生じるものとします。</p>
        </Section>

        <Section title="9. お問い合わせ窓口">
          <p>本プライバシーポリシーに関するお問い合わせは、本サービスのお問い合わせフォームよりお願いいたします。</p>
        </Section>

        <div className="mt-10 text-sm text-stone-500">
          関連: <Link to="/terms" className="text-emerald-600 hover:underline">利用規約・免責事項</Link>
        </div>
      </main>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <section className="mb-7">
      <h2 className="font-display font-black text-lg text-stone-900 mb-2">{title}</h2>
      <div className="text-stone-700 text-sm leading-relaxed">{children}</div>
    </section>
  );
}
